import { useMutation } from '@tanstack/react-query';
import { updatePreferredDeliveryPoint } from './api';

export const useUpdatePreferredDeliveryPoint = () =>
  useMutation({
    mutationFn: updatePreferredDeliveryPoint,
  });
